
import { useState } from 'react';

interface EditingItem {
  id: string;
  quantity: number;
}

interface MutationLike {
  mutate: (params: {
    lineItemId: string;
    quantity: number;
    componentType: string;
    componentId: string;
    baseCost: number;
  }) => void;
  isPending?: boolean;
}

export const useQuantityEditor = (updateQuantityMutation: MutationLike) => {
  const [editingItem, setEditingItem] = useState<EditingItem | null>(null);

  const startEditingQuantity = (item: any) => {
    setEditingItem({
      id: item.id,
      quantity: item.quantity_in_base_units
    });
  };

  const cancelQuantityEdit = () => {
    setEditingItem(null);
  };

  const saveQuantityEdit = (item: any) => {
    if (!editingItem) return;
    
    updateQuantityMutation.mutate({
      lineItemId: item.id,
      quantity: editingItem.quantity,
      componentType: item.component_type,
      componentId: item.component_id,
      baseCost: item.unit_cost_snapshot || 0
    });
    setEditingItem(null);
  };

  const updateEditingQuantity = (quantity: number) => {
    if (editingItem) {
      setEditingItem({ ...editingItem, quantity });
    }
  };

  return {
    editingItem,
    startEditingQuantity,
    cancelQuantityEdit,
    saveQuantityEdit,
    updateEditingQuantity,
  };
};
